<template>
  <div>
    <NuxtLayout />
  </div>
</template>

<script setup>
  import { FetchError } from 'ofetch'
  import { clear } from 'idb-keyval'
  import { useNuxtApp } from '#app'
  import { $api } from '~/composables/useAPI'
  import { tr } from '~/assets/scripts/helpers'

  window.addEventListener('unhandledrejection', function (rej) {
    if (rej.reason instanceof FetchError) {
      console.warn(`FetchError Encountered - ${rej.reason}`)
      return
    }
    if (!window._error_logged) {
      window._error_logged = true
      $api('/api/logs/error', {
        method: 'POST',
        body: {
          error: `${rej.error ? rej.error.message : ''} - ${window.location.href}\n${rej.reason.stack}`,
          view: rej.reason
            ? `${window.location.href} \n${rej.reason.fileName}:${rej.reason.lineNumber}:${rej.reason.columnNumber}`
            : window.location.href,
        },
      }).then(() => {
        try {
          const app = useNuxtApp()
          app.$toast.error(
            tr(
              'An error has been encountered. Please reload the page, or contact support if the error persists',
            ),
            {
              duration: 10000,
            },
          )
        } catch (e) {
          console.error(e)
        }
      })
    }
    throw rej.reason
  })

  document.clearCache = async () => {
    sessionStorage.clear()
    localStorage.clear()
    await clear()
  }
</script>
